import React from 'react';
import { useDispatch } from 'react-redux';
import type { DossierEvent } from '../../api/events/interface';
import { useSelector } from '../store';
import { actions as eventsActions } from './logic';

interface EventsHookState {
  events: DossierEvent[];
  // Per-dossier presence, not the slice-wide action status (so a fetch for
  // one dossier doesn't mask missing data for another).
  hasData: boolean;
}

interface EventsHookHandler {
  fetchEvents: () => void;
}

const EMPTY: DossierEvent[] = [];

export default function useEventsHook(
  dossierId: string
): [EventsHookState, EventsHookHandler] {
  const dispatch = useDispatch();
  const events = useSelector((s) => s.events.events[dossierId] ?? EMPTY);
  const hasData = useSelector((s) => s.events.events[dossierId] !== undefined);

  const handler = React.useMemo<EventsHookHandler>(
    () => ({
      fetchEvents: () => {
        dispatch(eventsActions.fetchEvents(dossierId));
      },
    }),
    [dispatch, dossierId]
  );

  return [{ events, hasData }, handler];
}
